<template>
  <div class="paypal">
    <div class="paypal-message">
      <p>
        At this stage you would login using your Paypal username and password to authorise a transaction.
      </p>
      <a @click="goToConfirm">Click to continue</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Paypal',
  props: {

  },
  data () {
    return {
    }
  },
  methods: {
    goToConfirm: function (event) {
      this.$events.$emit('show-paypal', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  // Temp paypal page
  .paypal {
    position: fixed;
    background-color: rgb(255, 255, 255);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    .paypal-message {
      position: absolute;
      max-width: 360px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/library/paypal.vue